export default "__VITE_ASSET__D2POVli4__"